export const environment = {
  production: false,
  staging: true,
  apiUrl: 'https://staging-api.os.ulysses.al/api',
  ctApiUrl: 'https://staging-api.os.ulysses.al/api/ct',
  ctWsUrl: 'wss://staging-api.os.ulysses.al',
  wsUrl: 'wss://staging-api.os.ulysses.al',
  appVersion: '2.0.0',
  sentryDsn: '',
};
